import React from 'react'
import { Link } from '@contrast-security-inc/design-system-typography'
import { Tag } from './tag'

// displays horizontal list of tags that appends
// overflow tag with count of remaining tags
// that would not fit into width given
export const TagList = ({ tags, width, onClickOverflow, ...restProps }) => {
  const maxWidth = width - 74 // roughly esitmate the overflow tag
  const [tagsOverflowCount, setTagsOverflowCount] = React.useState(0)
  const [tagsVisible, setTagsVisible] = React.useState(tags)
  const [tagRefs, setTagRefs] = React.useState<
    React.MutableRefObject<HTMLDivElement>[]
  >([])
  const tagContainerRef = React.useRef<HTMLDivElement>(null)

  // create refs for all tags being displayed
  // so that we can measure their width
  React.useEffect(() => {
    setTagRefs(tagsVisible.map(() => React.createRef()))
  }, [tagsVisible])

  // when tags are updated ex. when a new tag is added or remooved.
  // so that we can measure their width
  React.useEffect(() => {
    setTagsVisible(tags)
    setTagsOverflowCount(0)
  }, [tags])

  // measure and apply overflow if necessary
  React.useLayoutEffect(() => {
    if (
      tagRefs.length === tags.length &&
      (tagContainerRef?.current?.scrollWidth || 0) > maxWidth
    ) {
      // find index of overflowing tag
      let totalWidth = 0
      let tagIndex = -1
      for (let i = 0; i < tagRefs.length; i++) {
        totalWidth += tagRefs[i].current?.offsetWidth || 0

        if (totalWidth > maxWidth) {
          tagIndex = i
          break
        }
      }

      if (tagIndex !== -1) {
        setTagsVisible(tags.slice(0, tagIndex))
        setTagsOverflowCount(tags.length - tagIndex)
      }
    }
  }, [tags, maxWidth, tagRefs, tagContainerRef])

  return (
    <div {...restProps} ref={tagContainerRef}>
      {tagsVisible.length === tagRefs.length &&
        [...tagsVisible].sort().map((tag, index) => (
          <Tag
            key={index}
            innerRef={function (i, ref) {
              tagRefs[i].current = ref
            }.bind(null, index)}
          >
            {tag}
          </Tag>
        ))}
      {tagsOverflowCount > 0 && (
        <Tag>
          <Link onClick={onClickOverflow}>+{tagsOverflowCount}</Link>
        </Tag>
      )}
    </div>
  )
}
